export default __webpack_public_path__ + "static/BMW E60-86e0fc5b52468e357da837a7faff4788.jpg";